import { Input } from 'antd';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

const { TextArea: TextAreaA } = Input;

type TextAreaProperties = ComponentProps<typeof TextAreaA>;

const TextArea = ({ placeholder, ...props }: TextAreaProperties) => {
  const { t } = useTranslation();

  return <TextAreaA placeholder={typeof placeholder === 'string' ? t(placeholder) : placeholder} {...props} />;
};

export default TextArea;
